<template>
  <div>
      <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',

  components: {
  },
  created(){
      axios.interceptors.request.use(
        (config) => {
            this.$store.commit('loading', true)
            return config
        },
        (error) => {
          console.log(error.response.status, error)
          if (error.response.status === 401) {
            this.$store.commit('logout')
          }
          this.$store.commit('loading', false)
          return Promise.reject(error)
        }
      )

      axios.interceptors.response.use(
        (response) => {
            this.$store.commit('loading', false)
            return response
        },
        (error) => {
          console.log(error.response.status, error)
          if (error.response.status === 401) {
            this.$store.commit('logout')
          }
          this.$store.commit('loading', false)
          return Promise.reject(error)
        }
      )
  },
  data: () => ({
    //
  }),
};
</script>
